import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import './icon-magic-search.scss';

export function IconMagicSearch({ classNames = '', iconClasses = 'with-gradient' }) {
  return (
    <span
      className={classnames(
        'icon-magic-search keep-style-in-critical-even-if-not-in-dom icon d-inline-block',
        classNames,
        iconClasses
      )}
      aria-hidden
    />
  );
}

IconMagicSearch.propTypes = {
  classNames: PropTypes.string,
  iconClasses: PropTypes.string,
};
